import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=330d1e7f&scoped=true&lang=pug&"
import script from "./YouTube.vue?vue&type=script&lang=js&"
export * from "./YouTube.vue?vue&type=script&lang=js&"
import style0 from "./YouTube.vue?vue&type=style&index=0&id=330d1e7f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d1e7f",
  null
  
)

export default component.exports